// extracted by mini-css-extract-plugin
export var link = "gamification-introduction-module--link--04406";
export var linksWrapper = "gamification-introduction-module--links-wrapper--78ab3";